<template>
    <div>
        <a-button
            v-permission="'setting.preSaleOrder.importConfig'"
            class="configImport" 
            type="primary" 
            size="small" 
            @click="handle('configImport')"
        >
            {{ $t('preSaleOrder.importConfig') }}
        </a-button>
        <a-button
            style="margin-left:10px" 
            class="configImport" 
            type="primary" 
            size="small" 
            @click="handle('downloadTemplate')"
        >
            {{ $t('preSaleOrder.downloadTemplate') }}
        </a-button>
        <a-button 
            v-permission="'setting.preSaleOrder.saveOrder'" 
            style="margin-left:10px" 
            type="primary" 
            status="success" 
            size="small" 
            :loading="loading_btn"
            :disabled="!isImport" 
            @click="saveOrder"
        >
            {{ $t('preSaleOrder.saveOrder') }}
        </a-button>
        <a-button
            style="margin-left:10px" 
            type="primary"
            size="small" 
            :disabled="!isSave" 
            @click="orderDetail"
        >
            {{ $t('preSaleOrder.orderDetail') }}
        </a-button>

        <a-modal 
            class="deliverModal"
            v-model:visible="visible"
            :title="$t('preSaleOrder.importConfig')" 
            width="55%"
            draggable
            :onBeforeOk="onBeforeOk" 
            @ok="handleOk"
        >
            <Form 
                :form="addForm" 
                @handleSelectChange="handleSelectChange"
            >
                <template v-slot:formBtn>
                    <a-upload
                        :file-list="fileList"
                        accept=".xlsx,.xls,.xlsm"
                        action=""
                        :limit="1"
                        :show-file-list="true"
                        :show-retry-button="false"
                        @change="uploadChange"
                    />
                    <div style="margin:5px 0 0 10px; font-size:13px; color:#aaa">{{ $t('preSaleOrder.tip1') }}</div>
                </template>
            </Form>
        </a-modal>
        
        <div class="tableDataList">
            <div class="info" v-if="isImport">
                <a-descriptions :data="descData" :column="4" :title="t('preSaleOrder.importConfig')" bordered/>
            </div>

            <a-tabs :active-key="activeKey" @change="changeTab">
                <a-tab-pane key="1" :title="t('preSaleOrder.availableSKUs')"></a-tab-pane>
                <a-tab-pane key="2" :title="t('preSaleOrder.unavailableSKUs')"></a-tab-pane>
                <a-tab-pane key="3" :title="t('preSaleOrder.unknownSKUs')"></a-tab-pane>
                <a-tab-pane key="4" :title="t('preSaleOrder.nopriceSKUs')"></a-tab-pane>
            </a-tabs>

            <a-tag v-if="activeKey == 1 && isImport" color="green" >{{ planVosLength }} {{ $t('preSaleOrder.availableSKUsOrders') }}</a-tag>
            <a-tag v-if="activeKey == 2 && isImport" color="orange">{{ soldOutVosLength }} {{ $t('preSaleOrder.unavailableSKUsOrders') }}</a-tag>
            <a-tag v-if="activeKey == 3 && isImport" color="gray" >{{ unKnowVosLength }} {{ $t('preSaleOrder.unknownSKUsOrders') }}</a-tag>
            <a-tag v-if="activeKey == 4 && isImport" color="arcoblue">{{ noPriceVosLength }} {{ $t('preSaleOrder.nopriceSKUsOrders') }}</a-tag>

            <div style="display:inline-block;margin-left:10px">
                <a-tag v-if="activeKey == 1 && isImport" color="green">{{ $t('preSaleOrder.bikeCount') }}{{ bikeQuantityMap.planBikeCount }} </a-tag>
                <a-tag v-if="activeKey == 2 && isImport" color="orange">{{ $t('preSaleOrder.bikeCount') }}{{ bikeQuantityMap.soldOutBikeCount }} </a-tag>
                <a-tag v-if="activeKey == 3 && isImport" color="gray">{{ $t('preSaleOrder.bikeCount') }}{{ bikeQuantityMap.unKnowBikeCount }} </a-tag>
                <a-tag v-if="activeKey == 4 && isImport" color="arcoblue">{{ $t('preSaleOrder.bikeCount') }}{{ bikeQuantityMap.noPriceBikeCount }} </a-tag>
            </div>

            <!-- Available SKU -->
            <Table 
                v-if="activeKey == 1"
                ref="tableRef"
                :table="table1"
                @expandRow="expandRow"
            >
                <!-- 父表格操作 -->
                <template v-slot:tableOperate="{ props }">
                    <a-button
                        type="primary" size="mini" 
                        style="margin: 1px;width: 90px;"
                        @click="handle('deliveryInfo',props.record)"
                    >{{ $t('preSaleOrder.deliveryInfo') }}</a-button>
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>
            </Table>

            <!-- Unavailable SKU -->
            <Table 
                v-if="activeKey == 2"
                ref="tableRef2"
                :table="table2"
                @expandRow="expandRow2"
            >
                <!-- 父表格操作 -->
                <template v-slot:tableOperate="{ props }">
                    <a-button
                        type="primary" size="mini" 
                        style="margin: 1px;width: 90px;"
                        @click="handle('deliveryInfo',props.record)"
                    >{{ $t('preSaleOrder.deliveryInfo') }}</a-button>
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>
            </Table>

            <!-- Unknown SKU -->
            <Table 
                v-if="activeKey == 3"
                :table="table3"
            >
                <template v-slot:columns="{ props }"> 
                    <div v-if="props.column.dataIndex == 'total_units'" :style="{'color': props.record.total_units > 0? 'red' : '#333'}">{{ props.record.total_units }}</div>
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>
            </Table>

            <!-- NoPrice SKU -->
            <Table 
                v-if="activeKey == 4"
                :table="table4"
            >
                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>
            </Table>
        </div>

        <!-- 交付信息 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="deliveryInfoVisible"
            :title="$t('preSaleOrder.deliveryInfo')" 
            width="75%"
            draggable
            :hide-cancel="true"
            @ok="deliveryInfoVisible = false"
        >
            <Table 
                :table="deliveryInfoTable"
            ></Table>
        </a-modal>

        <!-- 订单详情 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="orderDetailVisible"
            :title="$t('preSaleOrder.orderDetail')" 
            :width="700"
            draggable
            :render-to-body="false"
            :hide-cancel="true"
            @ok="deliveryInfoVisible = false"
        >
            <a-alert style="margin-bottom:20px;font-size: 13px; color: #666">{{ $t('preSaleOrder.oderNameTip') }}</a-alert>
            <div v-for="(item, index) in orderNames" :key="index" style="color:#555; padding: 5px 0;">
                {{ item }}
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { DealerOpenOrderListApi } from '@/api/DealerOpenOrderListApi.js';
    import { PreSaleOrderApi } from '@/api/PreSaleOrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { AddForm } from './queryConfig/PreSaleOrderQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const addForm = reactive(AddForm)
    const visible = ref(false)
    const deliveryInfoVisible = ref(false)
    const showConfirmBtn = ref(false)
    const activeKey = ref(1)
    const fileName = ref('')
    const fileList = ref([])
    const customer_info = ref({})
    const payment_type_discount_opt = ref([])
    const payment_with_days_discount_opt = ref([])
    const payment_day_opt = ref([])
    const customerAddressList = ref([])
    const loading = ref(false)
    const isImport = ref(false)
    const isSave = ref(false)
    const rowData = ref(null)
    const orderDetailVisible = ref(false)
    const loading_btn = ref(false)

    const tableRef = ref(null)
    const tableRef2 = ref(null)

    const planVosLength = ref(0)
    const soldOutVosLength = ref(0)
    const unKnowVosLength = ref(0)
    const noPriceVosLength = ref(0)
    const bikeQuantityMap = ref(null)
    const file_no = ref('')
    const orderNames = ref([])
    

    const descData = ref([
        {
            label: t('preSaleOrder.dealerName'),
            value: '',
            key:'dealer_name',
        }, {
            label: t('preSaleOrder.paymentType'),
            value: '',
            key:'payment_type',
        }, {
            label: t('preSaleOrder.paymentTypeDiscount'),
            value: '',
            key:'payment_type_discount',
        },  {
            label: t('preSaleOrder.paymentDay'),
            value: '',
            key:'payment_day',
        }, {
            label: t('preSaleOrder.invoiceAddress'),
            value: '',
            key:'invoice_address',
        }, {
            label: t('preSaleOrder.shippingAddress'),
            value: '',
            key:'shipping_address',
        }, {
            label: t('preSaleOrder.payWithDaysDiscountRate'),
            value: '',
            key:'pay_with_days_discount_rate',
        }, {
            label: t('preSaleOrder.taxRate'),
            value: '',
            key:'tax_rate',
        }, {
            label: t('preSaleOrder.country'),
            value: '',
            key:'country',
        }, {
            label: t('preSaleOrder.winterFinancing'),
            value: '',
            key:'winter_flag',
        }, {
            label: t('preSaleOrder.cashDiscountPeriod'),
            value: '',
            key:'pay_with_days_day',
        },
        //  {
        //     label: t('preSaleOrder.paymentPeriod'),
        //     value: '',
        //     key:'payment_due_date',
        // } 
    ])
    
    const innerColumns = ref([
            {
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: 140,
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('preSaleOrder.category'),
                dataIndex: 'category',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.model'),
                dataIndex: 'model',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.description'),
                dataIndex: 'description',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:250,
            },
            {
                title: t('preSaleOrder.type'),
                dataIndex: 'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.size'),
                dataIndex: 'size',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.color'),
                dataIndex: 'color',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title:t('preSaleOrder.unitPrice'),
                dataIndex: 'unit_price',
                key: 'unit_price',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.discount'),
                dataIndex: 'discount',
                key: 'discount',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.payAmount'),
                dataIndex: 'pay_amount',
                key: 'pay_amount',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.totalQty'),
                dataIndex: 'total_quantity',
                key: 'total_quantity',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
    ])
    const innerConfigs = ref({
        scroll: {
            x: 1000,
            y: 200,
        },
        stripe: false,
        bordered: false,
        size: 'large',
        loading: false,
        pagination: false,
    })

    // 交付信息表格
    const deliveryInfoTable = ref({
        datas:[],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: 140,
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.eta'),
                dataIndex: 'eta',
                key: 'eta',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.quantity'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.warehouse'),
                dataIndex: 'warehouse',
                key: 'warehouse',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('preSaleOrder.overdue'),
                dataIndex: 'overdue',
                key: 'overdue',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            rowClass:(record, rowIndex)=>{
                console.log(record, rowIndex, 'record, rowIndex')
                return record.overdue_val == true? 'red_bg' : ''
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const table1 = ref({
        datas:[],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                title: t('preSaleOrder.orderNo'),
                dataIndex: 'pre_order_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
                filterable: {
                    filter: (value, record) => record.pre_order_number.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('preSaleOrder.bikeQty'),
                dataIndex: 'bike_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.skuQty'),
                dataIndex: 'sku_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.deliveryDateByCustomer'),
                dataIndex: 'delivery_date_by_customer',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:220,
            },
            {
                title: t('preSaleOrder.shippingCostNoTax'),
                dataIndex: 'shipping_cost_no_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:150,
            },
            {
                title: t('preSaleOrder.taxRate'),
                dataIndex: 'tax_rate',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.discount'),
                dataIndex: 'discount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.paymentTypeDiscountAmountNoTax'),
                dataIndex: 'payment_type_discount_amount_no_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.netAmount'),
                dataIndex: 'net_amount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.taxAmount'),
                dataIndex: 'tax_amount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.total'),
                dataIndex: 'total',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.payWithDaysDiscountAmountInTax'),
                dataIndex: 'pay_with_days_discount_amount_in_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:250,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '120',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:false,
        },
    })
    const table2 = ref({
        datas:[],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                title: t('preSaleOrder.orderNo'),
                dataIndex: 'pre_order_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
                filterable: {
                    filter: (value, record) => record.pre_order_number.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('preSaleOrder.bikeQty'),
                dataIndex: 'bike_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.skuQty'),
                dataIndex: 'sku_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.deliveryDateByCustomer'),
                dataIndex: 'delivery_date_by_customer',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:220,
            },
            {
                title: t('preSaleOrder.shippingCostNoTax'),
                dataIndex: 'shipping_cost_no_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.taxRate'),
                dataIndex: 'tax_rate',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                title: t('preSaleOrder.paymentTypeDiscountAmountNoTax'),
                dataIndex: 'payment_type_discount_amount_no_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.payWithDaysDiscountAmountInTax'),
                dataIndex: 'pay_with_days_discount_amount_in_tax',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:250,
            },
            {
                title: t('preSaleOrder.netAmount'),
                dataIndex: 'net_amount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.taxAmount'),
                dataIndex: 'tax_amount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            // {
            //     title: t('preSaleOrder.total'),
            //     dataIndex: 'total',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            //     width:120,
            // },
            
        ],                   
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:false,
        }
    })
    const table3 = ref({
        datas:[],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                title: t('preSaleOrder.category'),
                dataIndex: 'category',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.category) 
                    },
                }
            },
            {
                title: t('preSaleOrder.articleNumber'),
                dataIndex: 'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:200,
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('preSaleOrder.model'),
                dataIndex: 'model',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.description'),
                dataIndex: 'description',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:250,
            },
            {
                title: t('preSaleOrder.type'),
                dataIndex: 'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.size'),
                dataIndex: 'size',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.color'),
                dataIndex: 'color',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.dealerPrice'),
                dataIndex: 'dealer_price',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                title: t('preSaleOrder.totalUnits'),
                dataIndex: 'total_units',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
                slotName:'slot'
            },
        ],                    
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        }
    })
    const table4 = ref({
        datas:[],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                title: t('preSaleOrder.category'),
                dataIndex: 'category',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.category) 
                    },
                }
            },
            {
                title: t('preSaleOrder.articleNumber'),
                dataIndex: 'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:200,
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('preSaleOrder.model'),
                dataIndex: 'model',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                title: t('preSaleOrder.description'),
                dataIndex: 'description',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:250,
            },
            {
                title: t('preSaleOrder.type'),
                dataIndex: 'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.size'),
                dataIndex: 'size',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.color'),
                dataIndex: 'color',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                title: t('preSaleOrder.dealerPrice'),
                dataIndex: 'dealer_price',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                title: t('preSaleOrder.totalUnits'),
                dataIndex: 'total_units',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
        ],                       
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        }
    })


    const changeTab = (val)=>{
        activeKey.value = val
    }

    const handle = async (type, row)=>{
        switch(type){
            case 'configImport':
                visible.value = true
                getSource()

                addForm.formField.forEach(i=>{
                    addForm.formData[i.key] = ''
                })
                addForm.formData.customer_entity_id = ''
                addForm.formField.find(i=>i.key == 'winter_flag').disabled = true
                addForm.formData.winter_flag = '0'
                fileList.value = []
                break;
            case 'deliveryInfo':
                deliveryInfoVisible.value = true
                rowData.value = JSON.parse(JSON.stringify(row))
                rowData.value.delivery_info_data.forEach((item,index)=>{
                    item.serial = index + 1
                })
                deliveryInfoTable.value.datas = rowData.value.delivery_info_data
                break;
            case 'downloadTemplate':
                let file_no = await getFileNo()
                console.log(file_no, 'file_no')
                downloadTemplate(file_no)
                break;
                
        }
    }

    const orderDetail = ()=>{
        orderDetailVisible.value = true
    }

    // 展开行
    const expandRow = (rowKey,record)=>{
        tableRef.value.expandedKeys = tableRef.value.expandedKeys.length !== 0? [record.id] : []
    }

    const expandRow2 = (rowKey,record)=>{
        tableRef2.value.expandedKeys = tableRef2.value.expandedKeys.length !== 0? [record.id] : []
    }

    const handleSelectChange = (val, opt, key)=>{
        console.log(val, opt, key, 'val, opt, key 88888')
        if(key == 'customer_erp_code'){
            let item = addForm.formField.find(i=>i.key == 'customer_erp_code')
            let opt = item.options.find(i=> i.value == val)

            addForm.formData.country = ''
            addForm.formData.payment_type = opt.payment

            handleSelectChange(opt.payment, '', 'payment_type')

            addForm.formData.payment_type_discount = opt.payment_type_discount
            addForm.formData.pay_with_days_discount_rate = opt.payment == 'By Invoice'? opt.payment_with_days_discount : ''
            addForm.formData.payment_day = opt.payment_day
            addForm.formData.pre_discount_rate = opt.pre_discount_rate * 100 + '%'

            getCustomer(val)

        }else if(key == 'payment_type'){
            for(let key in addForm.formData){
                if(key == 'payment_type_discount' || key == 'pay_with_days_discount_rate' || key == 'payment_day'){
                    addForm.formData[key] = ''
                }
            }
            if(addForm.formData.payment_type != 'By Invoice' && addForm.formData.payment_type != 'SEPA'){
                addForm.formData.payment_due_date = ''
                addForm.formData.pay_with_days_day = ''
            }

            let item1 = addForm.formField.find(i=> i.key == 'payment_type_discount')
            let item2 = addForm.formField.find(i=> i.key == 'pay_with_days_discount_rate')
            let item3 = addForm.formField.find(i=> i.key == 'payment_day')
            
            item1.options = []
            item2.options = []
            item3.options = []

            item1.disabled = false
            item2.disabled = val != 'By Invoice'
            item2.required = val == 'By Invoice'
            item3.disabled = false

            addForm.formField.find(i=>i.key == 'winter_flag').disabled = !(val == 'SEPA' || val == 'By Invoice')
            addForm.formData.winter_flag = val != 'SEPA' && val != 'By Invoice'? '0' :  addForm.formData.winter_flag !== ''? addForm.formData.winter_flag : '0'
            handleSelectChange(addForm.formData.winter_flag, '', 'winter_flag')

            payment_type_discount_opt.value.forEach(i=>{
                if(i.label == val){
                    item1.options.push({
                        label: `${i.value * 100}%`,
                        value:i.value,
                    })
                } 
            })
            if(val == 'By Invoice'){
                payment_with_days_discount_opt.value.forEach(i=>{
                    if(i.label == val){
                        item2.options.push({
                            label: `${i.value * 100}%`,
                            value:i.value,
                        })
                    } 
                })
            }
            payment_day_opt.value.forEach(i=>{
                if(i.label == val){
                    item3.options.push({
                        label: i.value,
                        value:i.value,
                    })
                } 
            })

            setPayWithDaysDay()

        }else if (key == 'customer_invoice_id') {
            let item1 = addForm.formField.find(i=> i.key == 'customer_invoice_id')
            let item2 = item1.options.find(i=> i.value == val)
            addForm.formData.country = item2.country

            setPayWithDaysDay()
        }else if(key == 'winter_flag'){
            addForm.formField.find(i=>i.key == 'payment_due_date').show = addForm.formData.winter_flag == '1'
            addForm.formField.find(i=>i.key == 'payment_day').show = addForm.formData.winter_flag == '0'
            addForm.formData.payment_due_date = (addForm.formData.payment_type == 'By Invoice' || addForm.formData.payment_type == 'SEPA') && addForm.formData.winter_flag == '1'? '2026-05-01' : ''
            setPayWithDaysDay()
        }
    }

    const setPayWithDaysDay = ()=>{
        console.log('设置')
        if (addForm.formData.winter_flag == '1' && addForm.formData.payment_type == 'By Invoice'){
            const country = addForm.formData.country
            if(!!country){
                addForm.formData.pay_with_days_day = country == 'Germany' || country == 'Austria' || country == 'Italy'? 14 :30
            }else{
                addForm.formData.pay_with_days_day = ''
            }

            addForm.formData.pay_with_days_discount_rate = '0.03'
        }else{
            addForm.formData.pay_with_days_day = ''
        }   
    }

    // 上传文件 
    const uploadChange = (fileItem)=>{
        if(fileItem[0].status == 'error'){
            fileList.value = []
            fileList.value = fileItem
        }
    }

    const onBeforeOk = ()=>{
        if(addForm.formData.customer_erp_code == ''){
            Message.error(t('preSaleOrder.dealerName')+ ' ' + t('base.noEmpty'))
            return false
        }if(addForm.formData.customer_id == ''){
            Message.error(t('preSaleOrder.shippingAddress')+ ' ' + t('base.noEmpty'))
            return false
        }if(addForm.formData.customer_invoice_id == ''){
            Message.error(t('preSaleOrder.invoiceAddress')+ ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.payment_type == ''){
            Message.error(t('preSaleOrder.paymentType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!(addForm.formData.payment_type == 'By Invoice' && addForm.formData.winter_flag == '1') && addForm.formData.payment_day == ''){
            Message.error(t('preSaleOrder.paymentDay')+ ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.payment_type_discount == ''){
            Message.error(t('preSaleOrder.paymentTypeDiscount')+ ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.payment_type == 'By Invoice' && addForm.formData.pay_with_days_discount_rate == ''){
            Message.error(t('preSaleOrder.payWithDaysDiscountRate')+ ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.tax_rate == ''){
            Message.error(t('preSaleOrder.taxRate')+ ' ' + t('base.noEmpty'))
            return false
        }else if(fileList.value.length == 0){
            Message.error(t('base.uploadFileTip'))
            return false
        }

        importFileGetList(fileList.value[0].file)
        return true
    }

    // 导入文件并获取列表
    const importFileGetList = async (file)=>{
        addForm.formData.pay_with_days_discount_rate = addForm.formData.pay_with_days_discount_rate === ''? 0 : addForm.formData.pay_with_days_discount_rate

        let form = {} 
        addForm.formField.forEach(i=>{
            if(i.key !== 'pre_discount_rate') 
                form[i.key] = addForm.formData[i.key]
        })
        form.customer_entity_id = addForm.formData.customer_entity_id
        if(!!addForm.formData.payment_due_date) form.payment_due_date = dateToTimestamp(`${addForm.formData.payment_due_date} 00:00:00`)
        
        const formData = new FormData()
        let blob = new Blob([JSON.stringify(form)],{type:'application/json'})
        formData.append('file', file)
        formData.append('customer_info',blob)

        table1.value.configs.loading = true
        let res = await PreSaleOrderApi.getInstance().importFile(formData)
        if(res.code == 0){
            Message.success(t('base.exportSuccess'))
            isImport.value = true
            activeKey.value = 1

            let code_item = addForm.formField.find(i=> i.key == 'customer_erp_code')
            let code_opt = code_item.options.find(i=> i.value == addForm.formData.customer_erp_code)
            let address_item = customerAddressList.value.find(i=> i.id == addForm.formData.customer_id)
            let invoice_address_item = customerAddressList.value.find(i=> i.id == addForm.formData.customer_invoice_id)

            let country = address_item.country == undefined? '-' : address_item.country
            let city = address_item.city == undefined? '-' : address_item.city
            let street = address_item.street == undefined? '-' : address_item.street
            let address = address_item.address == undefined? '-' : address_item.address

            let invoice_country = invoice_address_item.country == undefined? '-' : invoice_address_item.country
            let invoice_city = invoice_address_item.city == undefined? '-' : invoice_address_item.city
            let invoice_street = invoice_address_item.street == undefined? '-' : invoice_address_item.street
            let invoice_address = invoice_address_item.address == undefined? '-' : invoice_address_item.address

            descData.value.forEach(i=>{
                if(i.key == 'dealer_name'){
                    i.value = code_opt.label
                }
                if(i.key == 'payment_type'){
                    i.value = addForm.formData.payment_type
                }
                if(i.key == 'payment_type_discount'){
                    i.value = Number(addForm.formData.payment_type_discount) * 100 + '%'
                }
                if(i.key == 'pay_with_days_discount_rate'){
                    i.value = Number(addForm.formData.pay_with_days_discount_rate) * 100 + '%'
                }
                if(i.key == 'payment_day'){
                    i.value = (addForm.formData.payment_type == 'By Invoice' || addForm.formData.payment_type == 'SEPA') && addForm.formData.winter_flag == '1'? addForm.formData.payment_due_date : addForm.formData.payment_day
                }
                if(i.key == 'tax_rate'){
                    i.value = Number(addForm.formData.tax_rate) * 100 + '%'
                }
                if(i.key == 'shipping_address'){
                    i.value = `${country}, ${city}, ${street}, ${address}`
                }
                if(i.key == 'invoice_address'){
                    i.value = `${invoice_country}, ${invoice_city}, ${invoice_street}, ${invoice_address}`
                }
                if(i.key == 'country'){
                    i.value = addForm.formData.country
                }
                if(i.key == 'winter_flag'){
                    i.value = addForm.formData.winter_flag == 0? 'No' : 'Yes'
                }
                if(i.key == 'pay_with_days_day'){
                    i.value = addForm.formData.pay_with_days_day 
                }
            })
      
            bikeQuantityMap.value = res.data.bikeQuantityMap

            res.data.planVos.length > 0 && res.data.planVos.forEach((item,index)=>{
                item.serial = index + 1
                item.id = index + 1
                item.tax_rate = item.tax_rate == undefined? '-' : Number(item.tax_rate) * 100 + '%'
                item.delivery_date_by_customer = item.delivery_date_by_customer == undefined? '-' : timestampToDate(item.delivery_date_by_customer * 1000).split(' ')[0]
                item.net_amount = item.net_amount == undefined? '-' : `${item.net_amount} €`
                item.tax_amount = item.tax_amount == undefined? '-' : `${item.tax_amount} €`
                item.shipping_cost_no_tax =  item.shipping_cost_no_tax == undefined? '-' : `${item.shipping_cost_no_tax} €`
                item.total = item.total == undefined? '-' : `${item.total} €`
                item.discount = `${item.discount} €`
                item.child = {
                    innerDatas:item.lines.map(m=>{
                        return {
                            ...m,
                            unit_price: `${m.unit_price} €`,
                            discount: `${m.discount} €`,
                            pay_amount: `${m.pay_amount} €`,
                            type: m.type == undefined? '-' : m.type,
                            size: m.size == undefined? '-' : m.size,
                            color: m.color == undefined? '-' : m.color,
                        }
                    }),
                    innerColumns:innerColumns.value,
                    innerConfigs:innerConfigs.value,
                }
                item.delivery_info_data = []


                // console.log(item.delivery_info_data,'111')
                item.lines.length > 0 && item.lines.forEach(k=>{
                    // console.log(item.delivery_info_data,'222',k)
                    k.delivery_require_vos.length > 0 && k.delivery_require_vos.forEach(m=>{
                        // console.log(item.delivery_info_data,'333',m)
                        m.expectedDeliveries.length > 0 && m.expectedDeliveries.forEach(j=>{
                            item.delivery_info_data.push({
                                ...j,
                                eta: j.eta == undefined? '-' : timestampToDate(j.eta * 1000).split(' ')[0],
                                quantity: j.quantity == undefined? '-' : j.quantity,
                                warehouse: j.warehouse == undefined? '-' : j.warehouse,
                                overdue_val: j.overdue,
                                overdue: j.overdue == undefined? '-' : j.overdue == false? t('base.no') : t('base.yes'),
                                sku: k.sku,
                            })
                        })
                    })
                })
            })
            planVosLength.value = res.data.planVos.length
            table1.value.datas = res.data.planVos
            table1.value.configs.loading = false

            console.log(table1.value.datas,'table1.value.datas')


            res.data.soldOutVos.length > 0 && res.data.soldOutVos.forEach((item,index)=>{
                item.serial = index + 1
                item.id = index + 1
                item.pre_order_number = item.pre_order_number == undefined? '-' : item.pre_order_number
                item.bike_quantity = item.bike_quantity == undefined? '-' :item.bike_quantity
                item.sku_quantity = item.sku_quantity == undefined? '-' : item.sku_quantity
                item.shipping_cost_no_tax = item.shipping_cost_no_tax == undefined? '-' : item.shipping_cost_no_tax
                item.tax_rate = item.tax_rate == undefined? '-' : Number(item.tax_rate) * 100 + '%'
                item.delivery_date_by_customer = item.delivery_date_by_customer == undefined? '-' : timestampToDate(item.delivery_date_by_customer * 1000).split(' ')[0]
                item.net_amount = item.net_amount == undefined? '-' : `${item.net_amount} €`
                item.tax_amount = item.tax_amount == undefined? '-' : `${item.tax_amount} €`
                item.shipping_cost_no_tax =  item.shipping_cost_no_tax == undefined? '-' : `${item.shipping_cost_no_tax} €`
                item.payment_type_discount_amount_no_tax = item.payment_type_discount_amount_no_tax == undefined? '-' : `${item.payment_type_discount_amount_no_tax} €`
                item.pay_with_days_discount_amount_in_tax = item.pay_with_days_discount_amount_in_tax == undefined? '-' : `${item.pay_with_days_discount_amount_in_tax} €`
                item.child = {
                    innerDatas:item.lines.map(m=>{
                        return {
                            ...m,
                            unit_price: `${m.unit_price} €`,
                            type: m.type == undefined? '-' : m.type,
                            size: m.size == undefined? '-' : m.size,
                            color: m.color == undefined? '-' : m.color,
                        }
                    }),
                    innerColumns:innerColumns.value,
                    innerConfigs:innerConfigs.value,
                }
            })
            soldOutVosLength.value = res.data.soldOutVos.length
            table2.value.datas = res.data.soldOutVos
            

            let category_arr = []
            res.data.unKnowVos.length > 0 && res.data.unKnowVos.forEach((item,index)=>{
                item.serial = index + 1
                item.color = item.color == undefined? '-' : item.color 

                if(!category_arr.includes(item.category)){
                    category_arr.push(item.category)
                }
            })
            unKnowVosLength.value = res.data.unKnowVos.length
            table3.value.datas = res.data.unKnowVos

            table3.value.columns.forEach(i=>{
                if(i.dataIndex == 'category'){
                    i.filterable.filters = []
                    category_arr.forEach(m=>{
                        i.filterable.filters.push({
                            text: m,
                            value: m,
                        })
                    })
                }
            })


            let category_arr2 = []
            res.data.noPriceVos.length > 0 && res.data.noPriceVos.forEach((item,index)=>{
                item.serial = index + 1
                item.color = item.color == undefined? '-' : item.color 

                if(!category_arr2.includes(item.category)){
                    category_arr2.push(item.category)
                }
            })
            noPriceVosLength.value = res.data.noPriceVos.length
            table4.value.datas = res.data.noPriceVos

            table4.value.columns.forEach(i=>{
                if(i.dataIndex == 'category'){
                    i.filterable.filters = []
                    category_arr2.forEach(m=>{
                        i.filterable.filters.push({
                            text: m,
                            value: m,
                        })
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 确认信息
    const saveOrder = async ()=>{
        loading_btn.value = true

        addForm.formData.pay_with_days_discount_rate = addForm.formData.pay_with_days_discount_rate === ''? 0 : addForm.formData.pay_with_days_discount_rate

        let form = {} 
        addForm.formField.forEach(i=>{
            if(i.key !== 'pre_discount_rate') 
                form[i.key] = addForm.formData[i.key]
        })
        form.customer_entity_id = addForm.formData.customer_entity_id
        if(!!addForm.formData.payment_due_date) form.payment_due_date = dateToTimestamp(`${addForm.formData.payment_due_date} 00:00:00`)

        console.log(form, 'form 444444')

        const formData = new FormData()
        let blob = new Blob([JSON.stringify(form)],{type:'application/json'})
        formData.append('file', fileList.value[0].file)
        formData.append('customer_info',blob)

        let res = await PreSaleOrderApi.getInstance().confirmInfo(formData)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            isImport.value = false
            table1.value.datas = []
            table2.value.datas = []
            table3.value.datas = []
            table4.value.datas = []

            loading_btn.value = false
            isSave.value = true
            orderNames.value = res.data.orderNames
            orderDetailVisible.value = true
        }else{
            // Message.error(res.msg) 
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('preSaleOrder.saveTip'),
                hideCancel:true,
                okText:t('base.ok'),
                onOk:()=>{}
            });
            loading_btn.value = false
        }
    }

    // 支付方式
    const getPaymentTypeConfig = async ()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_type',
        }
        let res = await PreSaleOrderApi.getInstance().getPaymentTypeConfig(param)
        if(res.code == 0){
            let item = addForm.formField.find(i=> i.key == 'payment_type')
            item.options = []
            res.data.forEach(i => {
                item.options.push({
                    label: i.dict_sub_name, 
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 支付折扣率
    const getPayDiscountConfig = async ()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_type_discount',
        }
        let res = await PreSaleOrderApi.getInstance().getPayDiscountConfig(param)
        if(res.code == 0){
            payment_type_discount_opt.value = []
            res.data.forEach(i => {
                payment_type_discount_opt.value.push({
                    label: i.dict_sub_name, 
                    value: i.dict_sub_value == '0.00'? '0' : i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 现金折扣率
    const getCashDiscountConfig = async ()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_with_days_discount',
        }
        let res = await PreSaleOrderApi.getInstance().getCashDiscountConfig(param)
        if(res.code == 0){
            payment_with_days_discount_opt.value = []
            res.data.forEach(i => {
                payment_with_days_discount_opt.value.push({
                    label: i.dict_sub_name, 
                    value: i.dict_sub_value == '0.00'? '0' : i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 账期
    const getPayDayConfig = async ()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_type_day',
        }
        let res = await PreSaleOrderApi.getInstance().getPayDayConfig(param)
        if(res.code == 0){
            payment_day_opt.value = []
            res.data.forEach(i => {
                payment_day_opt.value.push({
                    label: i.dict_sub_name, 
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取税率
    const getTax = async ()=>{
        let res = await PreSaleOrderApi.getInstance().getTax()
        if(res.code == 0){
            let item = addForm.formField.find(i=>i.key == 'tax_rate')
            item.options = []

            for(let key in res.data){
                item.options.push({
                    label:`${Number(key) * 100}% (${res.data[key]})`,
                    value:key
                })
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 获取渠道
    const getSource = async ()=>{
        let param = {
            status:'A',
            type:1,
        }
        let res = await PreSaleOrderApi.getInstance().getSource(param)
        if(res.code == 0){
            let item = addForm.formField.find(i=>i.key == 'customer_erp_code')
            item.options = []

            res.data.forEach(i=>{
                item.options.push({
                    label:`${i.customer_name} | ${i.customer_number}`,
                    value:i.customer_number,
                    id: i.id,
                    payment: i.payment, // 支付方式
                    payment_type_discount: i.payment_type_discount === undefined? '' : `${i.payment_type_discount}`, // 默认支付折扣
                    payment_with_days_discount: i.payment_with_days_discount === undefined? '0.01' : `${i.payment_with_days_discount}`,
                    payment_day: `${i.payment_day}`, // 默认账期
                    pre_discount_rate: i.pre_discount_rate, // 预支付折扣
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取经销商对应的客户
    const getCustomer = async (code)=>{
        let param = {
            erp_code: code,
        }
        let res = await PreSaleOrderApi.getInstance().getCustomer(param)
        if(res.code == 0){
            addForm.formData.customer_entity_id = res.data[0].id
            addForm.formData.customer_id = ''
            addForm.formData.customer_invoice_id = ''

            addForm.formField.find(i=>i.key == 'customer_id').options = []
            addForm.formField.find(i=>i.key == 'customer_invoice_id').options = []

            console.log(res.data[0].id, addForm.formData.customer_entity_id, 'kk')
            getCustomerAddressList(res.data[0].id)
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户地址
    const getCustomerAddressList = async (id)=>{
        let param = {
            customer_entity_id: id,
        }
        let res = await PreSaleOrderApi.getInstance().getCustomerAddressList(param)
        if(res.code == 0){
            customerAddressList.value = res.data

            let item1 = addForm.formField.find(i=>i.key == 'customer_id')
            let item2 = addForm.formField.find(i=>i.key == 'customer_invoice_id')
            item1.options = []
            item2.options = []

            res.data.forEach(i=>{
                item1.options.push({
                    label: i.first_flag == 1? `* ${i.name_show}, ${i.city}, ${i.address}` : `${i.name_show}, ${i.city}, ${i.address}`,
                    value: i.id, 
                    name: i.name,
                })
                item2.options.push({
                    label: i.first_flag == 1?  `* ${i.name_show}, ${i.city}, ${i.address}` : `${i.name_show}, ${i.city}, ${i.address}`,
                    value: i.id, 
                    name: i.name,
                    country: i.country,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取文件编号
    const getFileNo = async ()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'pre_order_template',
        }
        let res = await PreSaleOrderApi.getInstance().getFileNo(param)
        if(res.code == 0){
            return res.data[0].dict_sub_value
        }else{
            Message.error(res.msg)
        }
    }


    // 下载模板
    const downloadTemplate = async (file_no)=>{
        let param = {
            file_name:'PreOrder2026.xlsm',
            file_no: file_no,
            category:'files',
        }

        let res = await PreSaleOrderApi.getInstance().downloadTemplate(param,'files')
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `PreOrder2026.xlsm`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.downloadSuccess'))
        }else{  
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getPaymentTypeConfig()
        getPayDiscountConfig()
        getCashDiscountConfig()
        getPayDayConfig()
        getTax()
    })

</script>

<style lang="less" scoped>
.importPannel{
    padding:20px;
    background:#fff;
    overflow: hidden;

    .configImport{
        float:right;
    }
}

.tableDataList{
    margin-top: 10px;
    padding: 10px;
    background:#fff;

    .info{
        margin-bottom: 10px;
    }
}

/deep/ .arco-tabs-nav-tab{
    background:#fff;
    padding-left: 8px;
}
/deep/ .arco-tabs-content{
    padding-top:6px;
}

/deep/ .arco-table-td{
    border-right: 1px solid #eee;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-cell{
    padding:8px 16px !important;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-upload-list-type-text .arco-upload-list-item-error .arco-upload-list-item-name-link,
/deep/ .arco-upload-list-type-text .arco-upload-list-item-error .arco-upload-list-item-name{
    color: #165dff;
}

/deep/ .arco-upload-icon-error{
    display:none;
}

/deep/ .arco-upload-wrapper{
    width:auto;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .red_bg{
    .arco-table-td{
        background: #f7acaf !important;
    }
}


/deep/ .arco-modal-body{
    height:400px;
    overflow: scroll;
}
</style>